import React from 'react';
import { Typography } from '@material-ui/core';
const SidebarMemberProfile = () => {
    return React.createElement(Typography, null, "Member Profile");
};
export default SidebarMemberProfile;
